import type { SWRConfiguration } from 'swr';

export const defaultSWROptions: SWRConfiguration = {
  revalidateOnFocus: false,
  shouldRetryOnError: false,
};
